// Firebase App (the core Firebase SDK) is always required and must be listed first
// If you are using v7 or any earlier version of the JS SDK, you should import firebase using namespace import
// import * as firebase from "firebase/app"
// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import "firebase/analytics";
import firebase from "firebase/app";
// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/firestore";


// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAopSB3gidOhgqaL3vTS6wbB2EadOQsgtw",
  authDomain: "anutc-app-ab5c8.firebaseapp.com",
  projectId: "anutc-app-ab5c8",
  storageBucket: "anutc-app-ab5c8.appspot.com",
  messagingSenderId: "330446124828",
  appId: "1:330446124828:web:3ed4ce348ad1e1657eecd9",
  measurementId: "G-XECVP39YTD"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig)

const firestore = firebase.firestore();
export const db = firestore